

export default function Container(theme) {
    return {
        MuiContainer: {
            styleOverrides: {
                root: {
                    [theme.breakpoints.up('lg')]: {
                        maxWidth: "900px", // для точки (min-width: 1200px)
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                    [theme.breakpoints.up('md')]: {
                        maxWidth: "900px", // для точки (min-width: 1200px)
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },
                    [theme.breakpoints.down('md')]: {
                        maxWidth: "900px", // для точки (min-width: 1200px)
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                    },

                    // Другие стили для контейнера здесь...
                },
            }
        }
    }
}